import abstractModel from '../../core/MercatelyModel';

const csrfToken = document.querySelector('[name=csrf-token]')?.content;
const resource = '/api/mia/chatbot/customers';

const model = abstractModel(resource);

model.resetMemory = (customerId) => (
  model.remove({}, { path: `${resource}/${customerId}/memory`, csrfToken })
);

export default model;
